
<div >
  <h1>It's Beta.  Way Beta!</h1>
  <p>
    It Is Written Studies is under construction!  That pretty much means that you can use this site, while we work on the site.  We'll be making changes quite frequently, but hope that won't cause you any significant inconvenience. 
  </p>
</div>
